import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { wethContract } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const useApproveWeth = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.weth;
  const presaleAddress = Environment.presaleContract;
  const contract = wethContract(tokenAddress, web3);

  const approveWeth = useCallback(
    async (amount) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");
      const nd = web3.utils.toWei(amount.toString(), "ether");

      try {
        return new Promise(async (resolve, reject) => {
          let gas;
          try {
            gas = await contract.methods
              .approve(presaleAddress, nd)
              .estimateGas({
                from: account,
              });
          } catch (err) {
            return reject(err);
          }

          contract.methods
            .approve(presaleAddress, nd)
            .send({ from: account, gas })
            .on("transactionHash", (hash) => {
              console.log("Approval tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("Approval confirmed:", receipt);
              resolve({ transactionHash: receipt.transactionHash, receipt });
            })
            .on("error", (error) => {
              console.error("Approval failed:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3],
  );

  return { approveWeth };
};

export default useApproveWeth;
